export default "__VITE_ASSET__CgqjQlwu__"